import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postLiveBiddetails, postLiveRoomData } from "../../../../../redux/action/liveRoom";
import {
  convertTo12HourFormat,
  notifyError,
} from "../../../../../helpers/helpers";

function SetAutoBids({
  liveOfferData,
  setIsModalOpen,
  bidPriceUpdateValue,
  timeEnded,
  cancelledRef,
  startTimer,
  index
}) {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state?.profileStore);
  const [autoBidValue, setAutoBidValue] = useState(null);
  const [myCurrentBid, setMyCurrentBid] = useState(0);
  const [checkRefershed, setCheckRefershed] = useState(false);
  const [myAutoBidSetup, setMyAutoBidSetup] = useState({});
  const [canBidStatus, setCanBidStatus] = useState(false);
  const [hasBid, setHasBid] = useState(false);


  useEffect(() => {
    if (profile?.organization === bidPriceUpdateValue?.bidDetails?.userId) {
      setMyCurrentBid(bidPriceUpdateValue?.bidDetails?.bidAmount);
      setMyAutoBidSetup(bidPriceUpdateValue);
      setCanBidStatus(false);
      setHasBid(true);
    } else {
      setCanBidStatus(true);
      setHasBid(false);
    }
  }, [bidPriceUpdateValue, profile]);

  const onSubmitAutoBid = async () => {
    if (timeEnded) {
      notifyError("Time has ended");
      return;
    }
    if (startTimer) {
      notifyError("Auction for this lot has not started yet");
      return;
    }
    const minBidValue =
      (bidPriceUpdateValue?.highestBid || liveOfferData?.startingPrice) +
      liveOfferData?.minimumBid;
    if (autoBidValue <= minBidValue) {
      notifyError("Auto bid value must be higher than the current bid.");
      return;
    }

    if (myCurrentBid === bidPriceUpdateValue?.highestBid) {
      notifyError("You already have the highest bid.");
      return;
    }
    setIsModalOpen(false)
    setCanBidStatus(false)
    const data = {
      bidAmount: null,
      offerId: liveOfferData?._id,
      auctionId: liveOfferData?.auction,
      userId: profile?._id,
      organizationId: profile?.organization,
      autoBidAmount: Number(autoBidValue),
    };
    cancelledRef.current = false;

    dispatch(postLiveRoomData(data)).then(() => {
      setCheckRefershed(true);
      dispatch(postLiveBiddetails(liveOfferData?.auction));
      setHasBid(true);
      setAutoBidValue(null);
    });
  };


  useEffect(() => {
    const isEligibleForAutoBid =
      !hasBid &&
      myAutoBidSetup?.bidDetails?.autoBidAmount >=
      bidPriceUpdateValue?.highestBid + 2 * liveOfferData?.minimumBid &&
      (checkRefershed
        ? profile?.organization !== bidPriceUpdateValue?.bidDetails?.userId
        : profile?.organization !== bidPriceUpdateValue?.lastBidByUserId) && canBidStatus &&
      myCurrentBid !== bidPriceUpdateValue?.highestBid &&
      !timeEnded;


    if (isEligibleForAutoBid && !cancelledRef.current) {
      const data = {
        bidAmount: null,
        offerId: liveOfferData?._id,
        auctionId: liveOfferData?.auction,
        userId: profile?._id,
        organizationId: profile?.organization,
        autoBidAmount: myAutoBidSetup?.bidDetails?.autoBidAmount,
      };
      setCanBidStatus(false)
      setTimeout(() => {
        if (!cancelledRef.current||!hasBid) {
          dispatch(postLiveRoomData(data)).then(() => {
            setCheckRefershed(true);
            setHasBid(true);
            dispatch(postLiveBiddetails(liveOfferData?.auction));
          })
        }
      }, 12000);
    }
  }, [
    hasBid,
    timeEnded,
    myAutoBidSetup,
    bidPriceUpdateValue,
    dispatch,
    liveOfferData,
    profile,
    myCurrentBid,
    checkRefershed,
    cancelledRef, canBidStatus
  ]);

  return (
    <div className="flex space-between">
      <div className="font-18px flex column gap-10px">
        <h6 className="cercle-purple-text margin-0px">
          Lot No: {index}
        </h6>
        <p className="">
          Starting Price: Rs {liveOfferData?.startingPrice}
        </p>
        <p>
          Min Bid:{" "}Rs {" "}
          {liveOfferData?.auctionType === "forwardAuction"
            ? liveOfferData?.minimumBid
            : liveOfferData?.maximumBid}
        </p>
        <p>
          Closing time:{" "}
          {convertTo12HourFormat(liveOfferData?.offerSchedule?.endTimeAndDate)}
        </p>
      </div>

      <p className="grey border-radius-12" style={{ width: "1.5px" }}></p>
      <div className="flex column gap-10px mr-2" style={{ width: "250px" }}>
        <h4>Auto Bid Price</h4>
        <span>
          <input
            type="number"
            value={autoBidValue || 0}
            className="input-tag-style input-width mr-2 font-20px"
            style={{
              border: "1px solid red",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
            onChange={(e) => setAutoBidValue(e.target.value)}
          />
          <p>
            *Auto bid Applied for{" "}
            <span className="cercle-purple-text">Rs {autoBidValue || 0}</span>
          </p>
        </span>
        <button
          className="pointer white-text cercle-purple"
          style={{ padding: "10px 35px", borderRadius: "8px" }}
          onClick={() => {
            onSubmitAutoBid();
          }}
        >
          Schedule Auto Bid Price
        </button>
      </div>
    </div>
  );
}

export default SetAutoBids;
